import notFoundCtrl from 'components/notFound/notFoundCtrl';
import forgotPasswordCtrl from 'components/forgotPassword/forgotPasswordCtrl';
import changePasswordCtrl from 'components/changePassword/changePasswordCtrl';
import noOrganizationsCtrl from 'components/noOrganizations/noOrganizationsCtrl';
import noVenuesCtrl from 'components/noVenues/noVenuesCtrl';
import loginCtrl from 'components/login/loginCtrl';
import appCtrl from 'components/app/appCtrl';
import stripeConnectSuccessCtrl from 'components/stripeConnectSuccess/stripeConnectSuccessCtrl';
import selectOrganizationCtrl from 'components/selectOrganization/selectOrganizationCtrl';
import organizationCtrl from 'components/organization/organizationCtrl';
//settings
import settingsCtrl from 'components/settings/settingsCtrl';
import settingsOrganizationCtrl from 'components/settingsOrganization/settingsOrganizationCtrl';
import settingsVenueCtrl from 'components/settingsVenue/settingsVenueCtrl';
import settingsVenueWidgetCtrl from 'components/settingsVenueWidget/settingsVenueWidgetCtrl';
import settingsAttributionsCtrl from 'components/settingsAttributions/settingsAttributionsCtrl';
import settingsIntegrationsCtrl from 'components/settingsIntegrations/settingsIntegrationsCtrl';
import settingsStaffCtrl from 'components/settingsStaff/settingsStaffCtrl';
import settingsServersCtrl from 'components/settingsServers/settingsServersCtrl';
import settingsPromotersCtrl from 'components/settingsPromoters/settingsPromotersCtrl';
import settingsMicroSiteConfigsCtrl from 'components/settingsMicroSiteConfigs/settingsMicroSiteConfigsCtrl';
import settingsMicroSiteConfigEditCtrl from 'components/settingsMicroSiteConfigEdit/settingsMicroSiteConfigEditCtrl';
//venue settings
import settingsVenueSettingsCtrl from 'components/settingsVenueSettings/settingsVenueSettingsCtrl';
import settingsVenueBillingCtrl from 'components/settingsVenueBilling/settingsVenueBillingCtrl';
import settingsVenueBusinessHoursCtrl from 'components/settingsVenueBusinessHours/settingsVenueBusinessHoursCtrl';
import settingsVenueFloorplansCtrl from 'components/settingsVenueFloorplans/settingsVenueFloorplansCtrl';
import settingsVenueScheduleInventoryCtrl from 'components/settingsVenueScheduleInventory/settingsVenueScheduleInventoryCtrl';
import settingsVenueReportScheduleCtrl from 'components/settingsVenueReportSchedule/settingsVenueReportScheduleCtrl';
//
import unauthorizedCtrl from 'components/unauthorized/unauthorizedCtrl';
import manageCtrl from 'components/manage/manageCtrl';
import manageReservationsCtrl from 'components/manageReservations/manageReservationsCtrl';
import manageGuestlistsCtrl from 'components/manageGuestlists/manageGuestlistsCtrl';
import manageInventoryCtrl from 'components/manageInventory/manageInventoryCtrl';
import manageNotesCtrl from 'components/manageNotes/controller';
import manageDaySettingsCtrl from 'components/manageDaySettings/controller';
import manageDashboardCtrl from 'components/manageDashboard/controller';
import manageExportListCtrl from 'components/manageExportList/manageExportListCtrl';
import eventsCtrl from 'components/events/eventsCtrl';
import createEventCtrl from 'components/createEvent/createEventCtrl';
import eventCtrl from 'components/event/eventCtrl';
import eventSettingsCtrl from 'components/eventSettings/eventSettingsCtrl';
import eventInventoryCtrl from 'components/eventInventory/eventInventoryCtrl';
import eventDashboardCtrl from 'components/eventDashboard/eventDashboardCtrl';
import eventWidgetsCtrl from 'components/eventWidgets/eventWidgetsCtrl';
import eventWidgetCtrl from 'components/eventWidget/eventWidgetCtrl';
import eventPromoterLinksCtrl from 'components/eventPromoterLinks/eventPromoterLinksCtrl';
import eventStatsCtrl from 'components/eventStats/eventStatsCtrl';
import accountCtrl from 'components/account/accountCtrl';
import accountSetupCtrl from 'components/accountSetup/accountSetupCtrl';
import accountProfileCtrl from 'components/accountProfile/accountProfileCtrl';
import welcomeCtrl from 'components/welcome/welcomeCtrl';
import performanceCtrl from 'components/performance/performanceCtrl';
import performanceReservationsCtrl from 'components/performanceReservations/performanceReservationsCtrl';
import performanceGuestListCtrl from 'components/performanceGuestList/performanceGuestListCtrl';
import performancePayoutsCtrl from 'components/performancePayouts/performancePayoutsCtrl';
import performancePayoutTransactionsCtrl from 'components/performancePayoutTransactions/performancePayoutTransactionsCtrl';
import performanceTallyCtrl from 'components/performanceTally/performanceTallyCtrl';
import performanceExportListCtrl from 'components/performanceExportList/performanceExportListCtrl';
import customerDatabaseCtrl from 'components/customerDatabase/customerDatabaseCtrl';
import customerEditCtrl from 'components/customerEdit/customerEditCtrl';
import customerDataExportsCtrl from 'components/customerDataExports/customerDataExportsCtrl';
import customerProfileCtrl from 'components/customerProfile/customerProfileCtrl';
import signUpCtrl from 'components/signUp/signUpCtrl';
import teamCtrl from 'components/team/teamCtrl';
import teamExternalEditCtrl from 'components/teamExternalEdit/teamExternalEditCtrl';
import teamStaffEditCtrl from 'components/teamStaffEdit/teamStaffEditCtrl';
import teamServerEditCtrl from 'components/teamServerEdit/teamServerEditCtrl';
//PROMOTER APP
import promoterEventsCtrl from 'components/promoter/events/eventsCtrl';
import promoterSalesCtrl from 'components/promoter/sales/salesCtrl';
import promoterSalesReservationsCtrl from 'components/promoter/salesReservations/salesReservationsCtrl';
import promoterSalesGuestlistsCtrl from 'components/promoter/salesGuestlists/salesGuestlistsCtrl';

function init(app) {
  if (!app) throw new Error('app is required');

  app.controller('notFoundCtrl', notFoundCtrl);
  app.controller('forgotPasswordCtrl', forgotPasswordCtrl);
  app.controller('changePasswordCtrl', changePasswordCtrl);
  app.controller('noOrganizationsCtrl', noOrganizationsCtrl);
  app.controller('noVenuesCtrl', noVenuesCtrl);
  app.controller('loginCtrl', loginCtrl);
  app.controller('appCtrl', appCtrl);
  app.controller('selectOrganizationCtrl', selectOrganizationCtrl);
  app.controller('stripeConnectSuccessCtrl', stripeConnectSuccessCtrl);
  app.controller('organizationCtrl', organizationCtrl);
  app.controller('settingsCtrl', settingsCtrl);
  app.controller('settingsOrganizationCtrl', settingsOrganizationCtrl);
  app.controller('settingsAttributionsCtrl', settingsAttributionsCtrl);
  app.controller('settingsMicroSiteConfigsCtrl', settingsMicroSiteConfigsCtrl);
  app.controller('settingsMicroSiteConfigEditCtrl', settingsMicroSiteConfigEditCtrl);
  app.controller('settingsVenueCtrl', settingsVenueCtrl);
  app.controller('settingsVenueSettingsCtrl', settingsVenueSettingsCtrl);
  app.controller('settingsVenueBillingCtrl', settingsVenueBillingCtrl);
  app.controller('settingsVenueBusinessHoursCtrl', settingsVenueBusinessHoursCtrl);
  app.controller('settingsVenueFloorplansCtrl', settingsVenueFloorplansCtrl);
  app.controller('settingsVenueScheduleInventoryCtrl', settingsVenueScheduleInventoryCtrl);
  app.controller('settingsVenueReportScheduleCtrl', settingsVenueReportScheduleCtrl);
  app.controller('settingsVenueWidgetCtrl', settingsVenueWidgetCtrl);
  app.controller('settingsIntegrationsCtrl', settingsIntegrationsCtrl);
  app.controller('settingsStaffCtrl', settingsStaffCtrl);
  app.controller('settingsServersCtrl', settingsServersCtrl);
  app.controller('settingsPromotersCtrl', settingsPromotersCtrl);
  app.controller('manageReservationsCtrl', manageReservationsCtrl);
  app.controller('manageGuestlistsCtrl', manageGuestlistsCtrl);
  app.controller('manageInventoryCtrl', manageInventoryCtrl);
  app.controller('manageNotesCtrl', manageNotesCtrl);
  app.controller('manageDashboardCtrl', manageDashboardCtrl);
  app.controller('manageDaySettingsCtrl', manageDaySettingsCtrl);
  app.controller('manageExportListCtrl', manageExportListCtrl);
  app.controller('manageCtrl', manageCtrl);
  app.controller('accountCtrl', accountCtrl);
  //events
  app.controller('eventsCtrl', eventsCtrl);
  app.controller('createEventCtrl', createEventCtrl);
  //event
  app.controller('eventCtrl', eventCtrl);
  app.controller('eventSettingsCtrl', eventSettingsCtrl);
  app.controller('eventInventoryCtrl', eventInventoryCtrl);
  app.controller('eventInventoryCtrl', eventInventoryCtrl);
  app.controller('eventDashboardCtrl', eventDashboardCtrl);
  app.controller('eventWidgetsCtrl', eventWidgetsCtrl);
  app.controller('eventWidgetCtrl', eventWidgetCtrl);
  app.controller('eventPromoterLinksCtrl', eventPromoterLinksCtrl);
  app.controller('eventStatsCtrl', eventStatsCtrl);
  //
  app.controller('accountSetupCtrl', accountSetupCtrl);
  app.controller('accountProfileCtrl', accountProfileCtrl);
  app.controller('welcomeCtrl', welcomeCtrl);
  app.controller('unauthorizedCtrl', unauthorizedCtrl);
  app.controller('performanceCtrl', performanceCtrl);
  app.controller('performanceReservationsCtrl', performanceReservationsCtrl);
  app.controller('performanceGuestListCtrl', performanceGuestListCtrl);
  app.controller('performancePayoutsCtrl', performancePayoutsCtrl);
  app.controller('performancePayoutTransactionsCtrl', performancePayoutTransactionsCtrl);
  app.controller('performanceTallyCtrl', performanceTallyCtrl);
  app.controller('performanceExportListCtrl', performanceExportListCtrl);
  app.controller('customerDatabaseCtrl', customerDatabaseCtrl);
  app.controller('customerEditCtrl', customerEditCtrl);
  app.controller('customerDataExportsCtrl', customerDataExportsCtrl);
  app.controller('customerProfileCtrl', customerProfileCtrl);
  app.controller('signUpCtrl', signUpCtrl);
  //
  app.controller('teamCtrl', teamCtrl);
  app.controller('teamExternalEditCtrl', teamExternalEditCtrl);
  app.controller('teamStaffEditCtrl', teamStaffEditCtrl);
  app.controller('teamServerEditCtrl', teamServerEditCtrl);
  //PROMOTER APP
  app.controller('promoterEventsCtrl', promoterEventsCtrl);
  app.controller('promoterSalesCtrl', promoterSalesCtrl);
  app.controller('promoterSalesReservationsCtrl', promoterSalesReservationsCtrl);
  app.controller('promoterSalesGuestlistsCtrl', promoterSalesGuestlistsCtrl);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/components/index.js